(function () {
  function initFaq(root) {
    root.querySelectorAll('.faq-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('open');

        root.querySelectorAll('.faq-item.open').forEach(function (openItem) {
          openItem.classList.remove('open');
          var openButton = openItem.querySelector('.faq-btn');
          if (openButton) {
            openButton.setAttribute('aria-expanded', 'false');
          }
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.sec, .step, .prod-card');

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('reveal', 'active');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, { threshold: 0.1 });

    items.forEach(function (item) {
      item.classList.add('reveal');
      observer.observe(item);
    });
  }

  function init(root) {
    document.body.classList.add('hv-static-landing-page');
    initFaq(root);
    initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#top.hero')) {
      init(document);
    }
  });

  document.addEventListener('shopify:section:load', function () {
    if (document.querySelector('#top.hero')) {
      init(document);
    }
  });
})();
